<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="card">
                    <div class="d-block py-5 px-2 px-md-4">
                        <h5 v-html="TEXTS.render('BOOKING_HISTORY_HEADER')" class="font-weight-bold ml-3" />
                        <entitlement-table-history />
                        <UpcomingCollectionSummary v-if="isBinCollectionEnabled" :addressId="addressId" :isCompactDisplay="false" />
                        <component :is="loadComponent" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';
    import EntitlementTableHistory from '../../../../common/components/EntitlementTableHistory';
    import HistoryDetails from './HistoryDetails';
    import HistoryAndMoreDetails from './HistoryAndMoreDetails';
    import UpcomingCollectionSummary from '../../home/components/UpcomingCollectionSummary';
    import Texts from '../../../../common/utils/Texts'
    export default {
        mixins: [GeneralBookingSettingMixin],
        components: {
            EntitlementTableHistory,
            HistoryDetails,
            HistoryAndMoreDetails,
            UpcomingCollectionSummary,
        },
        mounted() {
            this.loadComponent = this.isEnabledBinCollection ? 'HistoryAndMoreDetails' : 'HistoryDetails';
            // this.$store.dispatch('setActiveMultipleServiceBookingSetting')
        },
        data() {
            return {
                loadComponent: null,
                activeAddress : {id:192}
            }
        },
        computed: {
          TEXTS: () => Texts,
          addressId() {
            var urlQuery = this.$route.query
            var addressId = urlQuery.id
            return addressId
          },
          isBinCollectionEnabled(){
            var multipleServiceBookingSetting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
            return multipleServiceBookingSetting && multipleServiceBookingSetting.enable_bin_collection == 1
          }
        },
        beforeRouteLeave(to, from, next){
            setTimeout(() => {
                next();
            }, 500)
            
        },
        watch: {
            'isEnabledBinCollection': function(isIt) {
                this.loadComponent = isIt ? 'HistoryAndMoreDetails' : 'HistoryDetails';
            }
        }
    }
</script>